import { environment } from "./../../../environments/environment";
import { LocalService } from "./../../services/local.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import "rxjs/add/operator/map";
import "rxjs/add/operator/toPromise";
@Injectable({
  providedIn: "root",
})
export class SellersService {
  apiUrl = "";
  // JSON.parse(localStorage.getItem('client'))['apiUrl'] || environment.apiUrl;

  constructor(
    private http: HttpClient,
    public localService: LocalService,
  ) {
    if (localStorage.getItem("client")) {
      this.apiUrl = JSON.parse(localStorage.getItem("client"))["apiUrl"];
    } else {
      this.apiUrl = environment.apiUrl;
    }
  }
  getSellers(): Promise<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': localStorage.getItem('token')
    });
    return this.http.get(this.apiUrl + 'aggregator/listing-analytics/getSellerList', {
      headers: headers
    }).map((response) => response).toPromise();
  }
  getSellerFilter(search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "aggregator/listing-analytics/getSellerListWithFilter",
        search,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  getRegSellerFilter(search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl +
          "aggregator/listing-analytics/getRegisteredSellerWithFilter",
        search,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  getSellerDetails(recordId): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .get(
        this.apiUrl +
          "aggregator/listing-analytics/getSellerDetails?sellerID=" +
          recordId,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  deleteSeller(Id, {}): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "seller/deleteSeller/" + Id,
        {},
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  getSellersByName(term: string, status = ["ACTIVE", "INACTIVE", "SUSPENDED"]) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "seller/searchSeller",
        { search: { sellerName: term, status: status } },
        {
          headers: headers,
        },
      )
      .pipe(map((response) => response["Data"].slice(0, 10)));
  }
  getSellersByEmail(term: string): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "seller/searchSeller",
        { search: { emailID: term } },
        {
          headers: headers,
        },
      )
      .map((response) => {
        return response["Data"].filter((email) => email.emailID === term);
      })
      .toPromise();
  }
  updateSellerstatus(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "seller/updateSellerStatus", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  updateStatusNew(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "seller/updateStatusSeller/" + data["sellerID"],
        data,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  updateStatusSellerAdmin(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "seller/updateStatusSellerAdmin/" + data["sellerID"],
        data,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  updateStatusRider(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl +
          "aggregator/listing-analytics/updateStatusRider/" +
          data["riderID"],
        data,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  // Auto Complete Service Seller
  //  getSellerByName(term: string) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'x-access-token': localStorage.getItem('token')
  //   });
  //   return this.http
  //     .post(this.apiUrl + 'inventory/searchSeller',{ autosearchSeller: term }, {
  //       headers: headers
  //     }).pipe(
  //       map(response => response['Data'].filter(option => {
  //         return option.sellerName.toLowerCase().indexOf(term.toLowerCase()) === 0
  //       }))
  //     )
  // }
  // Products Lsiting
  createNewSeller(record): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "seller/createNewSeller", record, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  updateSeller(record): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "seller/updateSellerComplete", record, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  //Registered Vendors count for dashboard page

  getSellersCount(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .get(this.apiUrl + "seller/getSellersCount", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  //Top vendor Section data for dashboard Page
  getTopSellersData(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .get(this.apiUrl + "seller/getTopSellersData", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  /**
   * Delivery Configuration
   */
  createSellerConfig(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "seller/updateSellerConfig", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  deliveryDetails(Id): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "seller/listConfig/" + Id,
        {},
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }

  /**
   * Get Countries list
   */
  getAllCountries(data): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    return this.http
      .post(this.apiUrl + "seller/getCountries", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  /**
   * Get States list from country
   */
  getStatesOfCountry(country): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    return this.http
      .post(
        this.apiUrl + "seller/getStates/" + country,
        {},
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  /**
   * Get city list from state
   */
  getCitiesOfState(country, state): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    return this.http
      .post(
        this.apiUrl + "seller/getCities/" + country + "/" + state,
        {},
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
}
